"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const wavyhair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-wavyhair` : '') + (description ? ` desc-wavyhair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-wavyhair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-wavyhair"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.82 19.05c.5-.72.42-1.68-.17-2.33l-.77-.84a3.75 3.75 0 0 1-.13-4.93l.82-1c.6-.73.57-1.77-.06-2.47L11.08 7a3.75 3.75 0 0 1 .16-5.25l.49-.48a1 1 0 0 1 1.39 0c.38.37.38.98 0 1.35l-.5.48a1.88 1.88 0 0 0-.07 2.62l.43.48a3.75 3.75 0 0 1 .13 4.93l-.83 1c-.6.73-.56 1.77.07 2.47l.77.84a3.75 3.75 0 0 1 .33 4.66l-1.68 2.46a1 1 0 0 1-1.37.27.94.94 0 0 1-.27-1.33l1.69-2.46Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92 19.05c.5-.72.43-1.68-.16-2.33l-.77-.84a3.75 3.75 0 0 1-.13-4.93l.82-1c.6-.73.57-1.77-.06-2.47L5.19 7a3.75 3.75 0 0 1 .15-5.25l.5-.48a1 1 0 0 1 1.38 0c.39.37.39.98 0 1.35l-.49.48a1.88 1.88 0 0 0-.08 2.62l.44.48a3.75 3.75 0 0 1 .13 4.93l-.83 1c-.6.73-.57 1.77.07 2.47l.77.84a3.75 3.75 0 0 1 .33 4.66l-1.69 2.46a1 1 0 0 1-1.36.27.94.94 0 0 1-.27-1.33l1.68-2.46Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7 19.05c.5-.72.43-1.68-.16-2.33l-.77-.84a3.75 3.75 0 0 1-.13-4.93l.83-1c.6-.73.57-1.77-.07-2.47L16.97 7a3.75 3.75 0 0 1 .16-5.25l.49-.48a1 1 0 0 1 1.39 0c.38.37.38.98 0 1.35l-.5.48a1.88 1.88 0 0 0-.07 2.62l.43.48a3.75 3.75 0 0 1 .13 4.93l-.82 1c-.6.73-.57 1.77.06 2.47l.77.84a3.75 3.75 0 0 1 .33 4.66l-1.68 2.46a1 1 0 0 1-1.37.27.94.94 0 0 1-.27-1.33l1.69-2.46Z",
    fill: "#232323"
  }));
};
var _default = exports.default = wavyhair;